<template>
  <div class="left-toolbar">
    <v-tooltip bottom>
      <v-btn
        @click="$emit('clear')"
        slot="activator"
        icon>
        <v-icon>delete</v-icon>
      </v-btn>
      <span>刪除動作</span>
    </v-tooltip>

    <v-tooltip bottom>
      <v-btn
        :class="{'btn--disabled': !showBackgroundImage}"
        @click="showBackgroundImage = !showBackgroundImage"
        slot="activator"
        icon>
        <v-icon>image</v-icon>
      </v-btn>
      <span>隱藏or顯示白板圖</span>
    </v-tooltip>

    <v-tooltip bottom>
      <v-btn
        @click="$emit('rotate')"
        slot="activator"
        icon>
        <v-icon>rotate_90_degrees_ccw</v-icon>
      </v-btn>
      <span>旋轉白板圖</span>
    </v-tooltip>

    <v-tooltip bottom>
      <v-btn
        @click="mode = 'drag'"
        slot="activator"
        :class="mode === 'drag' ? 'accent black--text' : ''"
        icon>
        <v-icon>control_camera</v-icon>
      </v-btn>
      <span>移動畫布</span>
    </v-tooltip>

    <v-tooltip bottom>
      <v-btn
        @click="mode = 'eraser'"
        slot="activator"
        :class="mode === 'eraser' ? 'accent black--text' : ''"
        icon>
        <v-icon>mdi-eraser</v-icon>
      </v-btn>
      <span>擦子</span>
    </v-tooltip>

    <v-tooltip bottom>
      <v-btn
        class="mb-4"
        slot="activator"
        @click="mode = 'pencil'"
        :class="mode === 'pencil' ? 'accent black--text' : ''"
        icon>
        <v-icon>mdi-lead-pencil</v-icon>
      </v-btn>
      <span>畫筆</span>
    </v-tooltip>

    <div
      class="color-btn elevation-2"
      :style="{'background-color': colorBlack}"
      @click="brushColor = colorBlack">
    </div>

    <div
      class="color-btn elevation-2"
      :style="{'background-color': colorRed}"
      @click="brushColor = colorRed">
    </div>

    <div
      class="color-btn elevation-2"
      :style="{'background-color': colorGreen}"
      @click="brushColor = colorGreen">
    </div>

    <div
      class="color-btn elevation-2"
      :style="{'background-color': colorBlue}"
      @click="brushColor = colorBlue">
    </div>

    <input
      class="color-picker-btn elevation-2 white mt-3"
      type="color"
      v-model="brushColor">

  </div>
</template>

<script>
export default {
  data() {
    return {
      colorBlack: '#000000',
      colorRed: '#e52020',
      colorGreen: '#598328',
      colorBlue: '#2025f4'
    };
  },

  computed: {
    mode: {
      get() {
        return this.$store.state.whiteboard.mode;
      },
      set(v) {
        this.$store.commit('whiteboard/updateStates', {mode: v});
      }
    },

    showBackgroundImage: {
      get() {
        return this.$store.state.whiteboard.showBackgroundImage;
      },
      set(v) {
        this.$store.commit('whiteboard/updateStates', {showBackgroundImage: v});
      }
    },

    brushColor: {
      get() {
        return this.$store.state.whiteboard.brushColor;
      },
      set(v) {
        this.$store.commit('whiteboard/updateStates', {brushColor: v});
      }
    }
  }
};
</script>

<style lang="stylus" scoped>

.left-toolbar {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0.5rem 0 0.5rem 0;
  width: 100%;
  border-right: 1px solid $def-border-color;
}

.color-picker-btn {
  flex-shrink: 0;
  width: 2rem;
  height: 2rem;
}

.color-btn {
  flex-shrink: 0;
  flex-grow: 0;
  cursor: pointer;
  border-radius: 50%;
  transition: 0.2s;
  width: 2.5rem;
  height: 2.5rem;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;

  &:hover {
    opacity: 0.9;
  }

  &:active {
    opacity: 0.7;
    box-shadow: $shadow-dark;
  }

  &:focus {
    opacity: 0.7;
    box-shadow: $shadow-dark;
  }
}
</style>
